package top.wcpe.allincore.dsl.ir.model.internal

/**
 * 只读保序 Set 视图（模块内共享工具）。
 *
 * 复刻原 Java `Collections.unmodifiableSet(new LinkedHashSet<>(...))` 语义：
 * - **保序**：委托构造期传入的 [backing]（约定为 LinkedHashSet），迭代顺序即插入序。
 * - **只读**：继承 Kotlin [AbstractSet]（只暴露只读契约、不实现可变方法），
 *   Java 侧对其调用 add / remove / clear 等会抛 [UnsupportedOperationException]，
 *   Java 调用方无法借静态闭集常量篡改全局共享状态。
 *
 * equals / hashCode 均委托 [backing]，与所包裹 Set 完全一致。
 *
 * commonMain 无 `java.util.Collections`，故用本类等价替代，`internal` 仅限 dsl-ir 内部使用。
 *
 * @param backing 已在构造方保序建好的底层 Set（本类不再拷贝，调用方负责传入独立实例）。
 */
internal class ReadOnlyOrderedSet<E>(
    private val backing: Set<E>,
) : AbstractSet<E>() {

    override val size: Int
        get() = backing.size

    override fun iterator(): Iterator<E> = backing.iterator()

    override fun contains(element: E): Boolean = backing.contains(element)
}
